function index (obj, key) {
    if (obj === undefined) { return null }
    if (typeof key === 'string') { return index(obj, key.split('.')) } else if (key.length === 0) { return obj } else { return index(obj[key[0]], key.slice(1)) }
}

export function __ (key, replace = {}) {
    let translation = index(window.translations, key)
        ? index(window.translations, key)
        : key

    Object.keys(replace).forEach(function (key) {
        translation = translation.replace(':' + key, replace[key])
    })

    return translation
}
